import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { setShowAllOptions } from 'store/ProductCatalog/filters/actions';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const ShowAllButtonLayout = ({ isMobile, className, slug, onClick }) => (
  <div className={cx('component', className, isMobile && 'mobile')}>
    <span
      className={cx('text', isMobile && 'mobile')}
      onClick={() => {
        onClick(slug);
      }}
      role="button"
      tabIndex={0}
    >
      Показать всё
    </span>
  </div>
);

ShowAllButtonLayout.propTypes = {
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  slug: PropTypes.string,
  onClick: PropTypes.func,
};

const mapDispatchToProps = {
  onClick: setShowAllOptions,
};

export default connect(null, mapDispatchToProps)(ShowAllButtonLayout);
